<script lang="ts" setup>
import type { CatalogPageRecord, ImageFileField } from "~~/server/graphql/datocms/generated";

defineProps<{ cmsData: CatalogPageRecord }>();

const localePath = useLocalePath();

const { status, error, content, pagination } = useCustomContentSearch({ initialize: false });
</script>

<template>
  <div v-if="status === 'error' || status === 'success'" class="gap-sm mb-md flex flex-col">
    <FeedbackMessage v-if="error" :msg="error.message" type="fail" />
    <FeedbackMessage v-else-if="!pagination.totalItems" :msg="cmsData.contentSearchMessageNoItems" type="warning" />
  </div>

  <div v-if="pagination.totalItems" class="gap-xl lg:gap-4xl flex flex-col">
    <div class="my-lg gap-lg md:gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      <article v-for="item of content" :key="item.id">
        <NuxtLink v-if="item.key === 'news'" :to="localePath({ name: 'news-slug', params: { slug: item.slug } })">
          <TeaserCard :page-id="item.id" :image="item.teaserImage as ImageFileField" :title="item.title" :text="item.teaserText" />
        </NuxtLink>

        <NuxtLink v-if="item.key === 'trends_inspiration'" :to="localePath({ name: 'trends-slug', params: { slug: item.slug } })">
          <TeaserCard :page-id="item.id" :image="item.teaserImage as ImageFileField" :title="item.title" :text="item.teaserText" />
        </NuxtLink>
      </article>
    </div>

    <ContentSearchPagination class="mx-auto" />
  </div>
</template>

<style scoped>

</style>
